<template>
    <div>
        <v-card elevation="0">
            <v-card-subtitle>
                <v-icon>mdi-information-outline</v-icon>&nbsp;All representatives listed below will receive daily email notifications of active postings.
            </v-card-subtitle>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined color="#74BDCB" @click="dialogAdd = true">Add New Representative</v-btn>
            </v-card-actions>
            <v-card-text>
                <v-card elevation="0" v-if="loadingget" height="200px" width="100%">
                    <v-row justify="center" align="center" class="fill-height">
                        <v-col cols="6">
                            <v-progress-linear
                                indeterminate
                                rounded
                                height="6"
                                color="#74BDCB"
                            ></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card>
                <v-simple-table v-else>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Comment</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="rep in cupereps" :key="rep.fullname">
                            <td>
                                {{ rep.fullname }}
                            </td>
                            <td>
                                {{ rep.email }}
                            </td>
                            <td>
                                {{ rep.comment }}
                            </td>
                            <td>
                                <v-row>
                                    <v-btn icon color="#EF7C8E" @click="openDialogDelete(rep)"><v-icon>mdi-delete-forever</v-icon></v-btn>
                                </v-row>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialogAdd" width="650px" persistent>
            <v-card>
                <v-toolbar dark color="#74BDCB" elevation="0">
                    <v-toolbar-title>New CUPE Representative</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            icon
                            dark
                            @click="closeDialogAdd"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar><br />
                <v-card-subtitle>This entry will be added to the existing list of CUPE representative(s) to receive the daily email notifications for the active postings.</v-card-subtitle>
                <v-card-text>
                    <v-row>
                        <v-col cols="12"><v-text-field v-model="newRepName" outlined hide-details label="Name"></v-text-field></v-col>
                        <v-col cols="12"><v-text-field v-model="newRepEmail" outlined persistent-hint hint="Please enter email precisely" label="Email Address"></v-text-field></v-col>
                        <v-col cols="12"><v-textarea v-model="newRepComment" outlined hide-details label="Additional Comment"></v-textarea></v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="#74BDCB" :loading="loadingadd" @click="addNewRep">Add new representative</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" width="650px" persistent>
            <v-card>
                <v-toolbar dark color="#EF7C8E" elevation="0">
                    <v-toolbar-title>Delete Representative from list</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            icon
                            dark
                            @click="closeDialogDelete"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar><br />
                <v-card-text>
                    The following CUPE representative will be removed from the emailing list of daily active postings notification: <br /><br />
                    <b>
                        Name: {{ deleteRep.fullname }} <br />
                        Email: {{ deleteRep.email }} <br />
                        Comment: {{ deleteRep.comment }}
                    </b><br /><br />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="#EF7C8E" :loading="loadingdelete" @click="deleteRepFromDB">Confirm Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            loadingget: false,
            cupereps: [],
            dialogAdd: false,
            dialogDelete: false,
            deleteRep: {},
            loadingadd: false,
            loadingdelete: false,
            newRepName: "",
            newRepEmail: "",
            newRepComment: ""
        }
    },
    methods: {
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        },
        initialize(){
            const that = this;

            that.getRepList();
            // that.cupereps = [
            //     {
            //         fullname: "Ramesses II",
            //         email: "kingsramessesii@email.yay",
            //         comment: "oh my god! Pyramids!"
            //     }
            // ]
        },
        getRepList(){
            const that = this;

            that.loadingget = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getFormControl&data={"type":"cuperepresentative"}';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            that.cupereps = json.data[0].config.list;
                        }else {
                            that.cupereps = [];
                        }
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }

                    that.loadingget = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.loadingget = false;
                })
        },
        addNewRep(){
            const that = this;

            that.loadingadd = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';

            let cupelist = that.cupereps;
            cupelist.push({
                "fullname" : that.newRepName,
                "email": that.newRepEmail,
                "comment": that.newRepComment
            })

            const formData = new FormData();

            formData.append("mode", "setFormControl");
            formData.append("data", JSON.stringify(
                {
                    type: "cuperepresentative",
                    list: cupelist
                }
            ));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Added new CUPE representative!", "#388E3C"); //green
                    }

                    that.loadingadd = false;
                    that.closeDialogAdd();
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.loadingadd = false;
                    that.closeDialogAdd();
                })
            //End of API calling
        },
        closeDialogAdd(){
            const that = this;

            that.dialogAdd = false;
            that.newRepName = "",
            that.newRepEmail = "",
            that.newRepComment = "";
        },
        removeItemFromArray(array, item){ 
            let index = array.indexOf(item);
            if(index > -1){
                array.splice(index, 1);
            }

            return array
        },
        openDialogDelete(rep){
            const that = this;
            that.deleteRep = rep;
            that.dialogDelete = true;
        },
        closeDialogDelete(){
            const that = this;
            that.dialogDelete = false;
            that.deleteRep = {};
        },
        deleteRepFromDB(){
            const that = this;
            that.loadingdelete = true;

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';

            let cupelist = that.cupereps;

            const formData = new FormData();

            formData.append("mode", "setFormControl");
            formData.append("data", JSON.stringify(
                {
                    type: "cuperepresentative",
                    list: that.removeItemFromArray(cupelist, that.deleteRep)
                }
            ));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Removed from CUPE representative list", "#388E3C"); //green
                    }

                    that.loadingdelete = false;
                    that.closeDialogDelete();
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.loadingdelete = false;
                    that.closeDialogDelete();
                })
            //End of API calling
        }

    },
    created(){
        const that = this;
        that.initialize();
    }
}
</script>